document.addEventListener('DOMContentLoaded', function () {
    const MOBILE_BREAKPOINT = 768
    const items = document.querySelectorAll('.how-we-works__item')
    const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT

    items.forEach(item => {
        const header = item.querySelector('.how-we-works__item-header')

        item.addEventListener('click', function () {
            if (isMobile()) return
            if (this.classList.contains('is-active')) return 

            items.forEach(el => el.classList.remove('is-active'))
            this.classList.add('is-active')
        })

        header.addEventListener('click', function () {
            if (!isMobile()) return

            const isAlreadyActive = item.classList.contains('is-active')
            items.forEach(el => el.classList.remove('is-active'))

            if (!isAlreadyActive) {
                item.classList.add('is-active')
            }
        })
    })
})